<template>
  <div class="" style="perspective: 128px">
    <nav
      id="mainmenu"
      class="relative text-xs font-semibold text-center text-white uppercase transition-all duration-500 ease-in-out origin-bottom xl:text-sm 2xl:text-lg text-opacity-70 transform-gpu"
      :class="{
        'translate-y-full': $route.path === '/',
      }"
    >
      <div
        class="relative flex items-center justify-center w-full h-12 transition duration-500 shadow-2xl xl:h-16 2xl:space-x-2 "
        :class="{
          'bg-primary-400 text-white': !$route.path.startsWith('/privileges'),
          'bg-black text-white': $route.path.startsWith('/privileges'),
        }"
      >
        <div ref="indicator" class="absolute bottom-0 h-12 transition-all duration-300 ease-in-out xl:h-16 bg-gold-500" />
        <RouterLink
          v-for="menu in pages"
          :key="menu.path"
          :to="menu.path"
          class="relative px-4 menuitem"
          active-class="text-white text-opacity-100 is-active"
          :class="{ 'pointer-events-none': menu.disabled }"
        >
          {{ menu.name }}
        </RouterLink>
      </div>
    </nav>
  </div>
</template>

<script>
import { nextTick, onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'

export default {
  setup () {
    const indicator = ref(null)
    const indicatorReady = ref(false)

    const pages = [
      { name: 'Project Concept', path: '/concept' },
      { name: 'Location', path: '/location' },
      { name: 'Project Info', path: '/info' },
      { name: 'Plans', path: '/plans' },
      { name: 'Facilities', path: '/facilities' },
      { name: 'Gallery', path: '/gallery' },
      { name: 'Animation', path: '/animation' },
      { name: 'Virtual Tours', path: '/virtual-tours' },
      { name: 'Privileges', path: '/privileges' },
      { name: 'Contact', path: '/contact' },
    ]

    const route = useRoute()

    const updateIndicator = (element) => {
      if (!element) return

      const boundR = element.getBoundingClientRect()

      indicator.value.style.transform = 'translateY(0)'
      indicator.value.style.left = `${boundR.x}px`
      indicator.value.style.width = `${boundR.width}px`
    }

    watch(route, (value) => {
      nextTick(() => {
        if (indicatorReady.value) {
          updateIndicator(document.querySelector('#mainmenu > * > .is-active'))
        }
      })
    })

    onMounted(() => {
      setTimeout(() => {
        updateIndicator(document.querySelector('#mainmenu > * > .is-active'))
        indicatorReady.value = true
      }, 300)

      window.addEventListener('resize', () => {
        updateIndicator(document.querySelector('#mainmenu > * > .is-active'))
      })
    })

    return {
      pages,
      indicator,
    }
  },
}
</script>
